import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import { TimePickerWUT } from '../time-picker';
import { classes } from './date-time-field.st.css';
import styles from './date-time-field.module.scss';
import { DatePickerWUT } from '../date-picker/date-picker-wut';
export function DateTimeFieldWUT(_ref) {
  let {
    use24HourFormat = false,
    onBlur,
    onChange,
    onFocus,
    inputId,
    ariaLabelledBy,
    value,
    id,
    disabled,
    errors,
    hidePlaceholder,
    showDateLabels,
    required,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const [date, time] = useMemo(() => (value == null ? void 0 : value.split(' ')) ?? [], [value]);
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(styles.fields, classes.gap, {
      [styles.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy,
    required: required
  }, /*#__PURE__*/React.createElement(DatePickerWUT, {
    disabled: disabled,
    errors: errors,
    hidePlaceholder: hidePlaceholder,
    showDateLabels: showDateLabels,
    required: required,
    inputId: inputId,
    id: id,
    onChange: newDate => onChange([newDate, time].join(' ')),
    value: date
  }), /*#__PURE__*/React.createElement(TimePickerWUT, {
    inputId: inputId,
    disabled: disabled,
    readOnly: false,
    error: errors.TIME,
    hidePlaceholder: hidePlaceholder,
    showTimeLabel: showDateLabels,
    required: required,
    className: styles.time,
    "data-hook": `${id}-time`,
    use24Hours: use24HourFormat,
    onChange: newTime => onChange([date, newTime].join(' ')),
    value: time
  }));
}
//# sourceMappingURL=date-time-field-wut.js.map